import types from './mutations_types';

const actions = {
  multipleId: ({
    commit
  }, multipleId) => {
    commit(types.MULTIPLEID_COORDINATE_LIST, multipleId);
  }
};

export default actions;
